import { FC, useEffect, useState } from 'react'
import PresentationApi from '../../../../infrastructure/api/PresentationApi'
import { IPresentationModel } from '../../../../models/responses/PresentationModel'
import { PagedResponseModel } from '../../../../models/responses/PagedResponseModel'
import { IPaginationFilter } from '../../../../models/requests/PaginationFilter'
import { GenericTable } from '../../../components/tables/GenericTable'
import { TableHelperButtons } from '../../../components/buttons/TableHelperButtons'
import { TableHelperButtonEnum } from '../../../enums/TableHelperButtonEnum'
import { Link } from 'react-router-dom'

type Props = {
  onClickItem: (itemId: any, itemName: string, type: string) => void
  refresh: number
}

const PresentationListModal: FC<Props> = ({ onClickItem, refresh }) => {
  const [presentations, setPresentations] = useState<PagedResponseModel<IPresentationModel[]>>()
  const [pageNumber, setPageNumber] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [searchText, setSearchText] = useState('')
  const [sort, setSort] = useState('name_asc')

  useEffect(() => {
    const paginationFilter: IPaginationFilter = {
      page: pageNumber,
      size: pageSize,
      orderBy: sort,
      search: searchText,
    }
    async function getPresentations() {
      var response = await PresentationApi.GetPresentations(paginationFilter)
      setPresentations(response.data)
    }
    getPresentations()
  }, [refresh, pageNumber, pageSize, searchText, sort])

  return (
    <>
      <GenericTable
        title='Presentations'
        data={presentations?.items}
        currentTotalRecords={presentations?.totalRecords!!}
        currentPageNumber={presentations?.pageNumber!!}
        columns={[
          {
            label: '#',
            name: '#',
            options: {
              customBodyRenderLite: (dataIndex) => {
                return <>{(pageNumber - 1) * pageSize + ++dataIndex}</>
              },
              sort: false,
              viewColumns: false
            },
          },
          {
            label: 'Name',
            name: 'name',
            options: {
              customBodyRender: (value) => {
                return <b>{value}</b>
              },
            },
          },
          { label: 'Link', name: 'link' },
          {
            label: 'File', name: 'file', options: {
              customBodyRenderLite: (dataIndex) => {
                return (
                  <a href={process.env.REACT_APP_CDN_URL + "files/presentation/" + presentations?.items[dataIndex].file!!} target="_blank" download><i className="fas fa-download"></i></a>
                )
              },
              sort: false
            }
          },
          {
            label: '#',
            name: 'Id',
            options: {
              customHeadLabelRender: (options) => {
                return (
                  <div className='d-flex justify-content-end flex-shrink-0'>{options.label}</div>
                )
              },
              customBodyRenderLite: (dataIndex) => {
                return (
                  <TableHelperButtons
                    itemId={presentations?.items[dataIndex]?.id!!}
                    itemParam={presentations?.items[dataIndex]?.name!!}
                    types={[TableHelperButtonEnum.Update, TableHelperButtonEnum.Delete]}
                    onClickItem={onClickItem}
                  />
                )
              },
              filter: false,
              sort: false,
              viewColumns: false,
            },
          },
        ]}
        customOptions={{
          rowsPerPage: pageSize,
          customTableBodyFooterRender: (opts) => {
            return <div></div>
          },
        }}
        setPageNumber={setPageNumber}
        setPageSize={setPageSize}
        setSearchText={setSearchText}
        setSort={setSort}
      />
    </>
  )
}

export { PresentationListModal }
